/** 画板图层 / 颜色 / 文字 / 工具常量 */
export const LAYER_PREFIX = 'zhxt-draw';
export const SOURCE_ID = `${LAYER_PREFIX}-source`;
export const LINE_LAYER = `${LAYER_PREFIX}-line`;
export const FILL_LAYER = `${LAYER_PREFIX}-fill`;
export const POINT_LAYER = `${LAYER_PREFIX}-points`;
export const PREVIEW_SOURCE = `${LAYER_PREFIX}-preview`;
/** 预览线独立 source：只含 LineString，避免与点混用 + filter 漏绘 */
export const PREVIEW_LINE_SOURCE = `${LAYER_PREFIX}-preview-line-src`;
export const PREVIEW_LINE = `${LAYER_PREFIX}-preview-line`;
export const PREVIEW_FILL = `${LAYER_PREFIX}-preview-fill`;
export const PREVIEW_POINTS = `${LAYER_PREFIX}-preview-points`;
/** 绘制中预览色（右键定型后切到「完成色」） */
export const DRAFT_LINE_COLOR = '#ff9800';
/** 选中时顶点高亮（线本身保持完成色，避免与预览橙混淆） */
export const SELECTED_VERTEX_COLOR = '#7c3aed';

/** 文字工具可选字体 */
export const FONT_OPTIONS = [
  { label: '微软雅黑', value: '"Microsoft YaHei", "PingFang SC", sans-serif' },
  { label: '黑体', value: '"SimHei", "Heiti SC", sans-serif' },
  { label: '宋体', value: '"SimSun", "Songti SC", serif' },
  { label: '楷体', value: '"KaiTi", "Kaiti SC", serif' },
  { label: '仿宋', value: '"FangSong", "STFangsong", serif' },
  { label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
  { label: '系统默认', value: 'system-ui, sans-serif' }
];

export const DEFAULT_TEXT_STYLE = {
  fontFamily: FONT_OPTIONS[0].value,
  fontSize: 16,
  letterSpacing: 0,
  lineHeight: 1.4,
  color: '#134e4a',
  bgColor: '#ffffff',
  bgEnabled: true,
  opacity: 0.95
};

export const DRAFT_TOOLS = ['route', 'measure', 'polygon', 'rectangle'];
/** ESC 长按判定（毫秒）：超过则清空全部草稿点 */
export const ESC_LONG_PRESS_MS = 450;
